var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8523",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8527"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8537"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path8535"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8529",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8533",
    clipPath: "url(#clipPath8537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8539",
    transform: "translate(85.531,393.0164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c -12.09,0 -21.891,9.801 -21.891,21.891 v 36.758 c 0,12.09 9.801,21.891 21.891,21.891 12.09,0 21.891,-9.801 21.891,-21.891 V 21.891 C 21.891,9.801 12.09,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8541"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8543",
    transform: "translate(331.2878,393.0164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c -12.09,0 -21.891,9.801 -21.891,21.891 v 36.758 c 0,12.09 9.801,21.891 21.891,21.891 12.09,0 21.891,-9.801 21.891,-21.891 V 21.891 C 21.891,9.801 12.09,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8547",
    transform: "translate(419.0046,393.0164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c -12.09,0 -21.891,9.801 -21.891,21.891 v 36.758 c 0,12.09 9.801,21.891 21.891,21.891 12.09,0 21.891,-9.801 21.891,-21.891 V 21.891 C 21.891,9.801 12.09,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8549"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8551",
    transform: "translate(251.487,135.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -58.406",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8553"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8555",
    transform: "translate(455.5563,105.8309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-15.617 -8.667,-27.975 -22.419,-28.215 -4.577,-0.08 -16.407,-0.124 -16.407,-0.124 0,0 -0.073,20.529 -0.073,28.401 0,6.465 -0.041,28.278 -0.041,28.278 h 16.051 C -7.806,28.34 0,15.617 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8557"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8559",
    transform: "translate(115.4177,135.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 41.087,-58.406",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8561"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8563",
    transform: "translate(153.614,135.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -41.146,-58.406",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8567",
    transform: "translate(297.194,104.5038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 24.534,-27.876",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8569"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8571",
    transform: "translate(290.1511,135.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -58.406",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8575",
    transform: "translate(321.7282,119.8543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.383 -7.351,-15.179 -16.038,-15.179 -4.309,0 -15.412,-0.066 -15.412,-0.066 0,0 -0.071,11.019 -0.071,15.245 0,3.471 -0.038,15.18 -0.038,15.18 h 15.521 C -7.351,15.18 0,8.384 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8579",
    transform: "translate(187.6677,135.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -58.406",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8583",
    transform: "translate(220.7351,118.5516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-9.103 -7.702,-16.482 -16.805,-16.482 -4.514,0 -16.149,-0.073 -16.149,-0.073 0,0 -0.073,11.967 -0.073,16.555 0,3.769 -0.04,16.482 -0.04,16.482 h 16.262 C -7.702,16.482 0,9.103 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8587",
    transform: "translate(382.444,134.7674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -24.385 V -57.873 H 0",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8589"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8591",
    transform: "translate(380.6462,105.8309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -21.587",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8595",
    transform: "translate(80.8288,134.7674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -24.385 V -57.873 H 0",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8597"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8599",
    transform: "translate(79.031,105.8309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -21.587",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8601"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8603",
    transform: "translate(91.8689,38.4432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -58.197 C -72.651,0 -84.369,11.718 -84.369,26.172 V 301.879 H 87.403",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8605"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8607",
    transform: "translate(427.114,340.3221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 77.386 v -275.707 c 0,-14.454 -11.717,-26.172 -26.172,-26.172 h -356.459",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8609"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8611",
    transform: "translate(336.6462,340.3221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 60.468",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8613"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8615",
    transform: "translate(148.5065,432.4569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -36.832",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8617"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8619",
    transform: "translate(305.4489,432.4569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -110.311",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8621"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8623",
    transform: "translate(393.8845,432.4569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -35.808",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8627",
    transform: "translate(504.4997,330.3221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 70.42 c 0,17.516 -14.199,31.715 -31.714,31.715 h -26.64",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8631",
    transform: "translate(61.404,432.4569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -22.189 c -17.516,0 -31.715,-14.199 -31.715,-31.715 v -70.42",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8633"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8635",
    transform: "translate(173.2478,393.0164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c -12.09,0 -21.891,9.801 -21.891,21.891 v 36.758 c 0,12.09 9.801,21.891 21.891,21.891 12.09,0 21.891,-9.801 21.891,-21.891 V 21.891 C 21.891,9.801 12.09,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8637"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8639",
    transform: "translate(358.0768,273.0008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-56.376 -45.701,-102.077 -102.077,-102.077 -56.375,0 -102.076,45.701 -102.076,102.077 0,56.375 45.701,102.076 102.076,102.076 C -45.701,102.076 0,56.375 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8641"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8643",
    transform: "translate(254.3737,332.4432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -61.282 L 28.759,-90.041",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path8645"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.c4b59704.svg";
export { ForwardRef as ReactComponent };